import React, { PureComponent } from "react";
import { StyleSheet, Image, View, Text, Platform } from "../core";
import Touchable from "./TouchableComponent";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import selete_icon_active from "../assets/images/selete_icon_active.png";
import selete_icon_normal from "../assets/images/selete_icon_normal.png";
export default class RadioButtons extends PureComponent {
  render() {
    const { options, onValueChange, isSelected, radioButtonsClass, touchableHolder, textOnly } = this.props;
    let imgpath =
      isSelected === options.value ? selete_icon_active : selete_icon_normal;
    return (
      <Touchable style={[touchableHolder]}
        onPress={() => onValueChange(options.value)}>
        <View style={[styles.buttonContainer, Platform.OS === "web" && commonStyles.flex1, commonStyles.flexDirectionRow, radioButtonsClass, commonStyles.flexGrow0, !!textOnly && isSelected === options.value && styles.active]}>
         {!!textOnly ? null : <Image resizeMode="contain" style={[styles.imgCls, commonStyles.icon15]} source={imgpath} /> }
          <Text style={[commonFontStyles.workSans, commonMetricsStyle.heading6, commonStyles.singleFullFlexItem, commonStyles.height15, commonStyles.fontWeight400, commonStyles.smallHeading, commonStyles.contentColor, !!textOnly ? styles.height0 : null, !!textOnly && isSelected === options.value && commonStyles.fontWeight600]}>{options.label}</Text>
        </View>
      </Touchable>
    );
  }
}

const styles = StyleSheet.create({
  buttonContainer: {
    paddingTop: 6,
    paddingBottom: 6,
    minHeight: 20,
  },
  imgCls: {
    marginRight: 10,
  },
  active:{    
    paddingBottom: 16,
    borderBottomWidth: 2,
    borderStyle: "solid",
    borderColor: "#0b4a87",
    color: "0b4a87"
  },
  height0:{
    height: 0
  }
});
